module.exports = __webpack_public_path__ + "img/16d001-10.b2eeb6dd.jpg";